import React, { useState, useEffect, useRef } from 'react';
const FontSize       = window.Quill.import('attributors/style/size')
const FontStyle      = window.Quill.import('attributors/style/font')
const AlignStyle     = window.Quill.import('attributors/style/align')

const fontSizes    = ['10pt', '8pt', '9pt', '12pt', '14pt']
FontSize.whitelist = fontSizes

window.Quill.register(FontSize,       true)
window.Quill.register(AlignStyle,     true)
window.Quill.register(FontStyle,      true)

export const normalToolbar = [
  [{ 'size': fontSizes }],
  ['bold', 'italic', 'underline', {'color': []}],
  [{ 'align': null}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
  [{'list': 'ordered'}, {'list': 'bullet'}],
  ['clean', 'link']
]

const blogToolbar = [
  [{ 'font': [] }, { 'size': fontSizes }],
  [ 'bold', 'italic', 'underline', 'strike' ],
  [{ 'color': [] }, { 'background': [] }],
  [{ 'script': 'super' }, { 'script': 'sub' }],
  [{ 'header': ['1', '2', '3', '4', '5', '6'] }, 'blockquote', 'code-block' ],
  [{ 'list': 'ordered' }, { 'list': 'bullet'}],
  [ 'direction', { 'align': [] }],
  [ 'link', 'image', 'video', 'formula' ],
  [ 'clean' ]
]

// The project quote PDF forces its own font and colour on descriptions.
const compactToolbar = [
  ['bold', 'italic', 'underline'],
  [{ 'list': 'ordered' }, { 'list': 'bullet' }],
  ['clean']
]

const compactFormats = ['bold', 'italic', 'underline', 'list']

const toolbar = config =>
  config == "blog"    ? blogToolbar    :
  config == "compact" ? compactToolbar :
                        normalToolbar

const QuillInput = props => {
  const {
    text,
    name,
    onChange,
    config,
    readOnly,
    placeholder,
    onEnter
  } = props

  const quillRef    = useRef(null)
  const didMountRef = useRef(false)
  const onChangeRef = useRef();
  onChangeRef.current = onChange;
  const onEnterRef  = useRef();
  onEnterRef.current  = onEnter;

  const [value, setValue] = useState(null)

  useEffect(() => {
    const quill = new window.Quill(quillRef.current, {
      theme: 'snow',
      readOnly: !!readOnly,
      placeholder,
      modules: {
        toolbar:   toolbar(config),
        clipboard: true,
        history:   true,
        keyboard:  onEnter
          ? { bindings: { submit: { key: 'Enter', shiftKey: false, handler: () => { onEnterRef.current?.(); return false } } } }
          : true
      }
    })

    if (config == "compact") {
      quill.clipboard.addMatcher(Node.ELEMENT_NODE, (_node, delta) => {
        delta.ops = delta.ops.map(op => {
          if (!op.attributes) return op
          const kept = Object.entries(op.attributes).filter(([name]) => compactFormats.includes(name))
          return kept.length ? { ...op, attributes: Object.fromEntries(kept) } : { insert: op.insert }
        })
        return delta
      })
    }

    quill.clipboard.dangerouslyPasteHTML(text)
    if (!readOnly) {
      quill.on('text-change', (_delta, _oldDelta, source) => {
        if (source == 'user') {
          const content = quill.getSemanticHTML().replaceAll("<p></p>", "<p><br></p>")
          if (onChangeRef.current) {
            onChangeRef.current(content);
          }
          setValue(content)
        }
      })
    }
    didMountRef.current = true
  }, [])

  useEffect(() => {
    if (didMountRef.current && text != value) {
      const quill = window.Quill.find(quillRef.current)
      quill.clipboard.dangerouslyPasteHTML(text)
      setValue(text)
    }
  }, [text])

  return (
    <>
      <div ref = {quillRef} />
      <textarea
        value = {value || ''}
        name  = {name}
        hidden
        readOnly
      />
    </>
  ) 
};

export default QuillInput;
